'use client';

import React from 'react';
import { FormProvider } from 'react-hook-form';
import { Alert, Box, Typography } from '@mui/material';
import { SearchBox } from '@/features/station/word/SearchBox';
import { Loading } from '@/components/loader/Loading';
import { useLogic } from './logic';
import { PublicListingList } from '@/features/station/PublicListingList';
import { api_portalOfficeListing_filter } from '@/init/swagger';

type Props = {
  searchFilters: api_portalOfficeListing_filter[];
};

export const PublicSearchWordStationsPage: React.FC<Props> = ({
  searchFilters,
}) => {
  const { method, handleSearch, displayListings, errorMessage, isLoading } =
    useLogic();

  return (
    <Box sx={{ px: 15, py: 2, '@media (max-width: 600px)': { px: 2 } }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <FormProvider {...method}>
          <form onSubmit={method.handleSubmit(handleSearch)}>
            <SearchBox isPublicSearch={true} />
          </form>
        </FormProvider>

        {!!errorMessage && (
          <Alert severity="error" sx={{ whitespace: 'pre-line' }}>
            {errorMessage}
          </Alert>
        )}
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          pt: 3,
          pb: 4,
        }}
      >
        <Typography variant="JP/Body/m/Regular/Normal">
          キーワード:{method.getValues('portal_office_name')}
        </Typography>

        <Typography variant="JP/Heading/lg/Bold/Tight">
          検索された看護・介護サービス
        </Typography>
      </Box>

      <PublicListingList
        listings={displayListings}
        searchFilters={searchFilters}
      />
      <Loading isLoading={isLoading} />
    </Box>
  );
};
